export default __webpack_public_path__ + "static/nualang-logo-primary-ccee864f087b7cd45de90b906d42e1fa.svg";